import React from 'react';
import './ShareAlertModule.scss'
import {isInBocApp, isInWeChat} from "../../asstes/js/Utils";
import {showShareModules, showToast, showZhShareModules} from "../../asstes/js/IntegratedProcessing";
import history from "../../router/history";

class ShareAlertModule extends React.Component {
	createPost = () => {
		this.close()
		this.props.createPost && this.props.createPost()
	}

	close = () => {
		this.props.hideShareModule && this.props.hideShareModule()
	}

	shareWx = (type) => {
		if (isInWeChat()) {
			showShareModules(this.props.userCheckIn)
		} else if (isInBocApp()) {
			showZhShareModules(history.location.pathname, type && type === 'noCollect')
		} else {
			showToast('本活动只能在微信参与，请去微信打开本活动！')
		}
	}

	render() {
		const shareLeft = require('../../asstes/img/other/share/share-pic.png')
		const shareRight = require('../../asstes/img/other/share//share-icon.png')
		const {onlyBocApp} = this.props

		return <div className="share-alert-module">
			<p className="prompt" onClick={this.close}></p>
			<div className={`share-alert-module-content ${onlyBocApp ? 'flex-center-center' : 'flex-between-center'}`}>
				{
					!onlyBocApp ?
						<>
							<div className="share-alert-module-item flex-center-center" onClick={this.createPost}>
								<img className="share-img" src={shareLeft} alt=""/>
								<p className="share-text">生成祝福海报</p>
							</div>
							<div className="share-alert-module-item flex-center-center" onClick={this.shareWx}>
								<img className="share-img" src={shareRight} alt=""/>
								<p className="share-text">分享到微信</p>
							</div>
						</> :
						<div className="only-one-share-item flex-center-center" onClick={() => this.shareWx('noCollect')}>
							<img className="share-img" src={shareRight} alt=""/>
							<p className="share-text">去微信把红包领走吧</p>
						</div>
				}
			</div>
		</div>
	}
}

export default ShareAlertModule;
